// Strip everything but A-Z0-9 and uppercase — matches the backend normalize.
// Split out of AccessPending.jsx: react-refresh/only-export-components flags
// any non-component export colocated with a page component, and only scans
// .jsx/.tsx files, so a plain .js helper module is exempt.
export function normalizeCode(raw) {
    return (raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}
